<template>
  <div>
    <b-carousel id="carousel-1" v-model="slide" :interval="4000" controls indicators background="#ababab"
      img-width="1024" img-height="600" style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd" >
      
      <!-- Text slides with image -->
      <a :href="advertisement.url" target="_blank" :class="[{ 'noneEvent': advertisement.url == '' }]" v-for="advertisement in advertisements" :key="advertisement.advertisement_picture_id">
        <b-carousel-slide :img-src="advertisement.path" ></b-carousel-slide>
      </a>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  data() {
    return {
      slide: 0,
      advertisementApiUrl: `${process.env.VUE_APP_API_URL}/advertisement/picture_list`,
      advertisements: []
    };
  },
  mounted() {
    this.getAdvertisement();

  },
  methods: {
    async getAdvertisement() {
      const api = this.advertisementApiUrl + `?advertisement_id=2&language_id=0`;
      await this.axios.get(api).then((result) => {
        this.advertisements = result.data;

      });
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  }
}
</script>

<style>
.img-fluid {
  max-height: 446px !important;
  width: 100%;
  object-fit: cover;
  transition: all .5s;
}

.img-fluid:hover {
    transform: scale(1.02);
}
.carousel-item {
}
</style>
<style scoped>
#carousel-1 {
  margin-bottom: 35px;
}

#carousel-1 a {
  display: block;
}

.carousel-indicators li {
  width: 10px !important;
  height: 10px !important;
  border-radius: 50% !important;
}



@media (max-width: 568px) {
  #carousel-1 .carousel-inner .carousel-item img {
    aspect-ratio: 1024 / 720;
    max-height: 446px !important;
    object-fit: cover;
  }
}
.noneEvent {
  pointer-events:none;
}
</style>